import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { API } from "@/App";
import axios from "axios";
import { Link2 } from "lucide-react";
import MicrositeRenderer from "@/components/MicrositeRenderer";

const PublicMicrosite = () => {
  const { slug } = useParams();
  const [microsite, setMicrosite] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => { fetchMicrosite(); }, [slug]);

  const fetchMicrosite = async () => {
    try {
      const res = await axios.get(`${API}/m/${slug}`);
      setMicrosite(res.data);
    } catch {
      setError("Microsite tidak ditemukan");
    } finally {
      setIsLoading(false);
    }
  };

  // Track klik per link — kirim ke backend. link_id dipakai sebagai
  // identitas utama (stabil walau link diurutkan ulang oleh pemiliknya);
  // link_index ikut dikirim sebagai fallback untuk kompatibilitas mundur.
  const handleLinkClick = async (link, linkIndex) => {
    if (!microsite) return;
    try {
      await axios.post(`${API}/m/${slug}/click`, { link_id: link?.id, link_index: linkIndex });
    } catch {
      // silent fail — jangan ganggu user
    }
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (error || !microsite) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <Link2 className="w-16 h-16 mx-auto mb-4 text-muted-foreground opacity-50" />
          <h1 className="text-2xl font-bold mb-2">404</h1>
          <p className="text-muted-foreground mb-6">{error || "Microsite tidak ditemukan"}</p>
          <Link to="/"><Button>Kembali ke Home</Button></Link>
        </div>
      </div>
    );
  }

  // Tidak ada toggle tema di sini secara sengaja — tampilan microsite (gelap/
  // terang/gradien/ikut-sistem) sepenuhnya milik pembuatnya, seperti Linktree.
  // Kalau bg_mode-nya "auto", MicrositeRenderer sendiri yang mengikuti skema
  // warna OS pengunjung secara real-time.
  return (
    <div className="min-h-screen" data-testid="public-microsite">
      <MicrositeRenderer microsite={microsite} interactive onLinkClick={handleLinkClick} />
    </div>
  );
};

export default PublicMicrosite;
